//eslint-disable-next-line no-unused-vars
import * as React from 'react';
import { simpleTag } from '../Base';

export const FloatingLabel = simpleTag({
  displayName: 'FloatingLabel',
  tag: 'label',
  classNames: 'mdc-floating-label'
});

export default FloatingLabel;



// WEBPACK FOOTER //
// ./src/FloatingLabel/index.js